import React from "react";

const RoomInfo = ({ room, hotel, module }) => {
  if (!room || !hotel) return null;

  const connexionTablette = module?.tab_connect?.status === "OK" ? "Oui" : "Non";

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-bold mb-4" style={{ color: "#333333" }}>
        Informations de la chambre
      </h2>
      <div className="flex flex-wrap items-center gap-x-8 gap-y-2">
        <div className="flex items-baseline gap-1">
          <span className="text-sm font-normal" style={{ color: "#888888" }}>Nb de places :</span>
          <span className="text-sm font-normal" style={{ color: "#555555" }}>{room.nb_places ?? "N/A"}</span>
        </div>
        <div className="flex items-baseline gap-1">
          <span className="text-sm font-normal" style={{ color: "#888888" }}>ID dans la DB :</span>
          <span className="text-sm font-normal" style={{ color: "#555555" }}>{room.id}</span>
        </div>
        <div className="flex items-baseline gap-1">
          <span className="text-sm font-normal" style={{ color: "#888888" }}>Connexion tablette :</span>
          <span className="text-sm font-normal" style={{ color: "#555555" }}>{connexionTablette}</span>
        </div>
      </div>
    </div>
  );
};

export default RoomInfo;
